import { isBuildCRM } from '@/utils/EnvironmentUtils';
import PremiumImpactServicesCRM from './PremiumImpactServicesCRM';
import PremiumImpactServicesCRMMock from './PremiumImpactServicesCRMMock';

import PremiumImpactServices from './PremiumImpactServices';
import PremiumImpactServicesMock from './PremiumImpactServicesMock';

let isMockingService =
  process.env.VUE_APP_MOCKING_SERVICES === 'true' || process.env.VUE_APP_MOCKING_SERVICES === true;
if (process.env.VUE_APP_SERVICES && process.env.VUE_APP_SERVICES === 'enabled') {
  isMockingService = false;
}

let actualService;
let mockService;

if (isBuildCRM()) {
  actualService = PremiumImpactServicesCRM;
  mockService = PremiumImpactServicesCRMMock;
} else {
  actualService = PremiumImpactServices;
  mockService = PremiumImpactServicesMock;
}

export default isMockingService ? mockService : actualService;
